import React, { FC } from 'react';

import Stack from '@mui/material/Stack';
import MarkupInputs from 'components/MarkupInputs';
import Section from 'components/Section';
import TextField from 'components/TextField';
import PriceInput from 'components/PriceInput';

const PackageEditMainPrice: FC = () => (
  <Section id="price" title="Kaina">
    <Stack spacing={4}>
      <MarkupInputs />

      <TextField
        fullWidth
        name="remainingPaymentDeadlineDays"
        label="Kainos likučio apmokėjimo terminas"
        helperText="Kiek dienų iki kelionės pradžios būtina sumokėti kelionės kainos likutį"
      />

      <TextField
        component={PriceInput}
        fullWidth
        name="individualAdvance"
        label="Individualus avansas"
      />

      <TextField
        fullWidth
        type="number"
        name="alreadyPurchased"
        label="Jau nusipirko"
      />
    </Stack>
  </Section>
);

export default PackageEditMainPrice;
